export default "__VITE_ASSET__DPD8tcD4__"